module.exports = __webpack_public_path__ + "static/cashew_nuts_dieu_1-eb52e41df99afb961f39c86ac532c3da.jpg";